/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { createSlice } from '@reduxjs/toolkit'
import { accountAPI } from 'api/account'

/**********************************************************************************************************
 *    SLICE
 **********************************************************************************************************/
type Status = 'idle' | 'loading' | 'success' | 'error'

interface AccountState {
    twoFactor: {
        status: Status,
        identifier: string | undefined,
        type: string,
        setup: {
            secret: string
        }
    }
    emailLog: {
        id: string,
        subject: string,
        parseDate: string
    }
}

const initialState: AccountState = {
    twoFactor: {
        status: 'idle',
        identifier: '',
        type: '',
        setup: {
            secret: ''
        }
    },
    emailLog: {
        id: '',
        subject: '',
        parseDate: ''
    }
}

export const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        setEmailLog: (state, { payload }) => {
            state.emailLog = payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(
                accountAPI.endpoints.createTwoFactor.matchPending,
                (state) => {
                    state.twoFactor = { status: 'loading', identifier: '', type: '', setup: { secret: '' } }
                }
            )
            .addMatcher(
                accountAPI.endpoints.createTwoFactor.matchFulfilled,
                (state, { payload: setup, meta: { arg: { originalArgs: { identifier, type } } } }) => {
                    state.twoFactor = { status: 'success', identifier, type, setup }
                }
            )
            .addMatcher(
                accountAPI.endpoints.createTwoFactor.matchRejected,
                (state) => {
                    state.twoFactor = { status: 'error', identifier: '', type: '', setup: { secret: '' } }
                }
            )
            .addMatcher(
                accountAPI.endpoints.addTwoFactor.matchFulfilled,
                (state) => {
                    state.twoFactor = {
                        status: 'idle',
                        identifier: '',
                        type: '',
                        setup: {
                            secret: ''
                        }
                    }
                }
            )
    }
})

export const { setEmailLog } = accountSlice.actions

export default accountSlice.reducer
